<script lang="ts">
    export let classes: string = ""
</script>


<span class={`spinner ${classes}`}></span>

<style>
  .spinner {
    display: inline-block;
    border: 2px solid #ccc;
    border-top-color: #333;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-right: 8px;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
